<template>
  <v-container class="mt-4 ml-2" fluid>

    <v-row>
      <v-col cols="12">

        <v-card class="shadowCard">

          <!-- ================= HEADER ================= -->
          <v-card-title>
            <div class="d-flex align-center">
              <span class="text-subtitle-1">Vacaciones</span>
              <v-chip
                v-if="diasDisponibles !== null"
                color="primary"
                small
                class="ml-3"
              >
                <v-icon left small>mdi-calendar-check</v-icon>
                Días disponibles: {{ diasDisponibles }}
              </v-chip>
            </div>
            <v-spacer/>

            <v-btn
              v-if="diasDisponibles > 0 && puedeSolicitarVacaciones"
              color="orange"
              dark
              small
              tile
              @click="abrirDialogSolicitud"
            >
              <v-icon left small>mdi-plus</v-icon>
              Solicitar Vacaciones
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-0 pb-2">
            <div class="text-body-2">
              <div><strong>Fecha de ingreso:</strong> {{ fechaIngreso }}</div>
              <div v-if="diasParaSiguienteAnio">
                <div>
                  <strong>Años cumplidos:</strong> {{ diasParaSiguienteAnio.aniosCompletos }} {{ diasParaSiguienteAnio.aniosCompletos === 1 ? 'año' : 'años' }}
                </div>
                <div>
                  <strong>Días para cumplir {{ diasParaSiguienteAnio.siguienteAnio }} {{ diasParaSiguienteAnio.siguienteAnio === 1 ? 'año' : 'años' }}:</strong>
                  {{ diasParaSiguienteAnio.diasFaltantes === 0 
                      ? '¡Ya cumpliste este aniversario!' 
                      : diasParaSiguienteAnio.diasFaltantes + ' días' }}
                </div>
              </div>
              <div>
                <strong>Días usados:</strong> {{ diasUsados }}
              </div>
            </div>
          </v-card-text>


          <!-- ================= TABLA ================= -->
          <v-data-table
            :headers="headers"
            :items="vacaciones"
            dense
          >

            <!-- JEFE -->
            <template v-slot:item.respuesta_jefe="{ item }">
              <v-chip
                small
                dark
                class="pointer"
                :color="colorEstatus(item.respuesta_jefe)"
              >
                {{ textoEstatus(item.respuesta_jefe) }}
              </v-chip>
            </template>

            <!-- RH -->
            <template v-slot:item.respuesta_rh="{ item }">
              <v-chip
                small
                dark
                class="pointer"
                :color="colorEstatus(item.respuesta_rh)"
              >
                {{ textoEstatus(item.respuesta_rh) }}
              </v-chip>
            </template>

            <!-- ACCIONES -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="puedeEditarItem(item)"
                x-small color="primary" @click="editItem(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                v-if="puedeEliminarItem(item)"
                x-small
                color="error"
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>


    <!-- ================= DIALOG EDITAR/AGREGAR ================= -->
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>

        <v-card-title>
          {{ editedIndex === -1 ? 'Agregar Vacaciones' : 'Editar Vacaciones' }}
        </v-card-title>

        <v-card-text>

          <v-text-field
            v-model="editedItem.vacaciones"
            label="Vacaciones"
            filled dense
          />

          <v-autocomplete
            filled
            dense
            :clearable="false"
            v-model="editedItem.idtrabajador"
            :items="trabajadores"
            label="Selecciona un trabajador"
            prepend-inner-icon="mdi-account"
            single-line
            item-text="nombre_completo"
            item-value="id_usuario"
            :disabled="true"
          />

          <v-text-field
            v-model="editedItem.fecha_inicio"
            label="Fecha Inicio"
            type="date"
            filled dense
          />

          <v-text-field
            v-model="editedItem.fecha_fin"
            label="Fecha Fin"
            type="date"
            filled dense
          />

          <v-text-field
            v-model="editedItem.dias_vacaciones"
            label="Días vacaciones"
            type="number"
            min="0"
            max="40"
            filled
            dense
            readonly
          />

        </v-card-text>

        <v-card-actions>
          <v-btn text @click="close">Cancelar</v-btn>
          <v-spacer/>
          <v-btn color="green" dark @click="save">Guardar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

export default {

  computed : {
		...mapGetters('login',['getdatosUsuarioERPERP']),

    puedeSolicitarVacaciones () {
      
      if ( !this.fecha_Ingreso ) return false
      
      
      // 1) Si el iderp está en la lista de excepciones, puede solicitar
      if (this.iderpUsuariosTieneVacaciones.includes(this.getdatosUsuarioERPERP.iderp)) {
        return true
      }

      // 2) Validar que haya pasado al menos un año desde fecha_alta
      const fechaAltaStr = this.fecha_Ingreso // "2025-07-30 09:51:00"
      const [fechaSolo] = fechaAltaStr.split(' ') // "2025-07-30"
      const fechaAlta = new Date(fechaSolo)
      if (isNaN(fechaAlta)) return false
      
      const hoy = new Date()
      const unAnioDespues = new Date(fechaAlta)
      unAnioDespues.setFullYear(unAnioDespues.getFullYear() + 1)
      

      if( !(hoy >= unAnioDespues) ) return false

      return hoy >= unAnioDespues
    },

    fechaIngreso () {
      if (!this.fecha_Ingreso) return null

      const [fechaSolo] = this.fecha_Ingreso.split(' ') // "YYYY-MM-DD"
      const [y, m, d] = fechaSolo.split('-').map(Number)
      const fecha = new Date(y, m - 1, d)

      return fecha.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
      })
    },

    diasParaSiguienteAnio () {
      const usuario = this.getdatosUsuarioERPERP
      if ( !this.fecha_Ingreso ) return null

      const [fechaSolo] = this.fecha_Ingreso.split(' ')
      const [y, m, d] = fechaSolo.split('-').map(Number)
      const fechaAlta = new Date(y, m - 1, d)
      fechaAlta.setHours(0, 0, 0, 0) // Normalizar fecha de alta
      if (isNaN(fechaAlta)) return null

      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0) // Normalizar a medianoche para comparar solo fechas

      // Calcular cuántos años completos ha cumplido
      let aniosCompletos = 0
      let aniversarioActual = new Date(fechaAlta)
      
      // Calcular el siguiente aniversario (año actual + 1)
      let siguienteAniversario = new Date(fechaAlta)
      siguienteAniversario.setFullYear(siguienteAniversario.getFullYear() + 1)
      
      // Si ya pasó el primer aniversario, calcular cuántos años completos tiene
      while (siguienteAniversario <= hoy) {
        aniosCompletos++
        siguienteAniversario = new Date(fechaAlta)
        siguienteAniversario.setFullYear(siguienteAniversario.getFullYear() + aniosCompletos + 1)
      }

      // Calcular días faltantes para el siguiente aniversario
      const diffMs = siguienteAniversario - hoy
      const diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

      return {
        aniosCompletos: aniosCompletos,
        siguienteAnio: aniosCompletos + 1,
        diasFaltantes: diffDias <= 0 ? 0 : diffDias
      }
    },

    diasUsados () {
      if (!this.vacaciones || !this.vacaciones.length) return 0

      // Sumar solo las vacaciones aprobadas por Jefe y RH (1 = Aceptado)
      return this.vacaciones
        .filter(v => v.respuesta_jefe != 2 && v.respuesta_rh != 2)
        .reduce((acum, v) => acum + (Number(v.dias_vacaciones) || 0), 0)
    },


	},

  data: () => ({

    dialog:false,
    dialogRespuesta:false,

    vacaciones:[],
    trabajadores: [],
    iderpUsuariosTieneVacaciones: [], // solo para pruebas, los iderp que esten aquí podrán solicitar vacaciones
    iderpUsuariosPermitidosJefe: [],
    iderpUsuariosPermitidosRH: [ 68 ],
    diasDisponibles: null,
    fecha_Ingreso: null,

    headers:[
      { text:'ID', value:'idvacaciones' },
      { text:'Vacaciones', value:'vacaciones' },
      { text:'Empleado', value:'nombre_completo' },
      { text:'Fecha Inicio', value:'fecha_inicio' },
      { text:'Fecha Fin', value:'fecha_fin' },
      { text:'Días vacaciones', value:'dias_vacaciones' }, // ← NUEVA COLUMNA
      { text:'Jefe', value:'respuesta_jefe' },
      { text:'RH', value:'respuesta_rh' },
      { text:'Motivo Rechazo', value:'motivo_rechazo' },
      { text:'Actions', value:'actions', sortable:false }
    ],

    editedIndex:-1,

    editedItem:{
      idvacaciones:0,
      vacaciones:'',
      idtrabajador: 0,
      fecha_inicio:'',
      fecha_fin:'',
      dias_vacaciones:0
    },

    defaultItem:{
      idvacaciones:0,
      vacaciones:'',
      idtrabajador: 0,
      fecha_inicio:'',
      fecha_fin:'',
      dias_vacaciones:0
    },

    /* ===== respuesta rápida ===== */
    tipoRespuesta:'',
    itemRespuesta:null,
    respuestaTemp:0,
    motivoTemp:'',

    estatusItems:[
      { text:'Pendiente', value:0 },
      { text:'Aceptado', value:1 },
      { text:'Rechazado', value:2 }
    ]

  }),

  async created(){

    await this.obtenerDiasDisponibles()
    await this.getTrabajadores()
    this.initialize()
  },

  watch: {
    'editedItem.fecha_inicio': 'actualizarDiasVacaciones',
    'editedItem.fecha_fin'   : 'actualizarDiasVacaciones',
  },
  
  
  
  methods:{

    obtenerDiasDisponibles () {
      // getDiasDisponibles
      return this.$http
      .get(`vacaciones.get.dias.disponibles/${ this.getdatosUsuarioERPERP.iderp }`).then(response => {
        this.diasDisponibles = response.data.dias_disponibles || 0
        console.log( '///////////////' )
        console.log( this.diasDisponibles )
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    esJefe( id ) {

      this.cargar = true

      return this.$http
      .get(`vacaciones.es.jefe.directo/${id}`).then(response => {
        //console.log( this.getdatosUsuarioERPERP.idpuesto === response.data.id_puesto_jefe )
          return response.data.id_puesto_jefe
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    getTrabajadores () {
      this.cargar = true
      this.trabajadores = []

      console.log( this.getdatosUsuarioERPERP )

      return this.$http.get('vacaciones.get.trabajadores', {
        params: {
          id_puesto: this.getdatosUsuarioERPERP.idpuesto
        }
      })
        .then(response => {
          this.trabajadores = response.data.trabajadores
          console.log( 'trabajadores' )
          console.log( this.trabajadores )
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    initialize(){
      this.$http.get(`vacaciones.list.por.trabajador/${ this.getdatosUsuarioERPERP.iderp }`)
        .then(r=> this.vacaciones=r.data)
      this.$http.get(`vacaciones.get.fecha.ingreso.por.trabajador/${ this.getdatosUsuarioERPERP.iderp }`)
        .then( r=>{
          console.log( 'fecha_Ingreso data: ', r.data.fechaIngreso.fecha_ingreso )
           this.fecha_Ingreso=r.data.fechaIngreso.fecha_ingreso
          })
        .finally(() => {
          console.log( 'fecha_Ingreso: ', this.fecha_Ingreso )
        })
    },

    save () {
    const esEdicion = this.editedIndex > -1

    const req = esEdicion
      ? this.$http.put('vacaciones.update/' + this.editedItem.idvacaciones, this.editedItem)
      : this.$http.post('vacaciones.add', this.editedItem)

    req.then(() => {
      this.$swal({
        icon: 'success',
        title: esEdicion ? 'Solicitud actualizada' : 'Solicitud registrada',
        text: esEdicion
          ? 'La solicitud de vacaciones se actualizó correctamente.'
          : 'La solicitud de vacaciones se agregó correctamente.',
        confirmButtonText: 'Aceptar'
      })

      this.close()
      this.initialize()
      this.obtenerDiasDisponibles()
    }).catch(error => {
      const mensaje =
      error.response.data.message ||
      'Ocurrió un error al guardar la solicitud de vacaciones.'

      this.$swal({
        icon: 'error',
        title: 'Error',
        text: mensaje,
        confirmButtonText: 'Aceptar'
      })
    })
    },


    /* ================= UI ================= */

    editItem(item){
      this.editedIndex=this.vacaciones.indexOf(item)
      this.editedItem={...item}
      this.dialog=true
    },

     deleteItem (item) {
    this.$swal({
      title: '¿Eliminar solicitud?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.$http
          .put('vacaciones.eliminar/' + item.idvacaciones)
          .then(() => {
            this.$swal({
              icon: 'success',
              title: 'Eliminada',
              text: 'La solicitud de vacaciones fue eliminada correctamente.',
              confirmButtonText: 'Aceptar'
            })
            this.initialize()
            this.obtenerDiasDisponibles()
          })
          .catch(error => {
            this.validarError(error.response.data.message)
          })
      }
    })
  },

    close(){
      this.dialog=false
      this.editedItem={...this.defaultItem}
      this.editedIndex=-1
    },


    /* helpers visuales */
    textoEstatus(v){
      return ['Pendiente','Aceptado','Rechazado'][v]
    },

    colorEstatus(v){
      return ['grey','green','red'][v]
    },

    actualizarDiasVacaciones () {
      const inicio = this.editedItem.fecha_inicio
      const fin    = this.editedItem.fecha_fin

      if (!inicio || !fin) {
        this.editedItem.dias_vacaciones = 0
        return
      }

      // Parsear como fecha local, no como UTC
      const [y1, m1, d1] = inicio.split('-').map(Number)
      const [y2, m2, d2] = fin.split('-').map(Number)

      const fechaInicio = new Date(y1, m1 - 1, d1)
      const fechaFin    = new Date(y2, m2 - 1, d2)

      if (isNaN(fechaInicio) || isNaN(fechaFin) || fechaFin < fechaInicio) {
        this.editedItem.dias_vacaciones = 0
        return
      }

      let dias = 0
      const cursor = new Date(fechaInicio)

      while (cursor <= fechaFin) {
        const esDomingo = cursor.getDay() === 0 // 0 = domingo
        if (!esDomingo) {
          dias++
        }
        cursor.setDate(cursor.getDate() + 1)
      }

      this.editedItem.dias_vacaciones = dias
    },

    puedeEditarItem (item) {
      const iderp = this.getdatosUsuarioERPERP.iderp

      // Solo se puede editar si ambos siguen pendientes
      const siguePendiente =
        item.respuesta_jefe === 0 &&
        item.respuesta_rh   === 0

      if (!siguePendiente) return false

      const esJefeORH =
        this.iderpUsuariosPermitidosJefe.includes(iderp) ||
        this.iderpUsuariosPermitidosRH.includes(this.getdatosUsuarioERPERP.idpuesto)

      const esSuPropiaSolicitud = item.idtrabajador === iderp

      return esJefeORH || esSuPropiaSolicitud
    },

    puedeEliminarItem (item) {
      const iderp = this.getdatosUsuarioERPERP.iderp
      if (!iderp) return false

      // Solo se puede eliminar si ambos siguen pendientes
      const siguePendiente =
        item.respuesta_jefe === 0 &&
        item.respuesta_rh === 0

      if (!siguePendiente) return false

      // Puede eliminar si es RH o Jefe permitido
      const esJefePermitido = this.iderpUsuariosPermitidosJefe.includes(iderp)
      const esRHPermitido   = this.iderpUsuariosPermitidosRH.includes(iderp)

      // O si es el creador de la solicitud
      const esSuPropiaSolicitud = item.idtrabajador === iderp || item.id_usuario === iderp

      return esJefePermitido || esRHPermitido || esSuPropiaSolicitud
    },

    abrirDialogSolicitud () {
      // Reiniciar formulario a valores por defecto (modo "agregar")
      this.editedIndex = -1
      this.editedItem  = { ...this.defaultItem }

      const iderpUsuario = this.getdatosUsuarioERPERP.iderp

      const trabajadorActual = this.trabajadores.find(
        t => t.id_usuario === iderpUsuario
      )

      // El autocomplete usa item-value="id_usuario", y tu modelo es editedItem.idtrabajador
      this.editedItem.idtrabajador = trabajadorActual.id_usuario
        
      this.dialog = true
    },

    obtenerDiasDisponibles () {
      return this.$http
        .get(`vacaciones.get.dias.disponibles/${ this.getdatosUsuarioERPERP.iderp }`)
        .then(response => {
          this.diasDisponibles = response.data.dias_disponibles || 0
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

  }
}
</script>


<style scoped>
.pointer{
  cursor:pointer;
}
</style>
